import React from 'react';
import {ReactComponent as FileIconSvg} from 'resources/icons/file_icon.svg';

export function FileIcon() {
  return <FileIconSvg />;
}
